import axios from "axios";
const API = axios.create({ baseURL: "https://16d6zw.sse.codesandbox.io/user" });
export const signin = (formData) => API.post("/signin", formData);
export const signup = (formData) => API.post("/signup", formData);
export const verifyUser = ({ id, token }) => API.get(`/${id}/verify/${token}`);
